export default {
  feedback: {
    token_required: 'Klik op het vakje om te bevestigen dat je geen robot bent',
    frequent_requests:
      'Controleer je sms. We hebben de code al via sms naar het opgegeven nummer gestuurd. Zo niet, controleer dan het telefoonnummer of probeer het over 10 minuten opnieuw.',
  },
};
